import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { useI18NextContext } from '@components/hooks';
import { rTapNumberHTML, rTapNotifyDOMChangeWrapper } from '@components/common/r-tap-number';
import { getHTML } from '@util/common';

const Heading = styled.h3(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h3 as any),
  marginTop: 0
}));

const Description = styled.p({});

export const Container = styled.div(({ theme }: ThemeProps) => ({
  border: `1px solid ${theme.custom.states.selected.dark}`,
  backgroundColor: theme.custom.colors.group1.lighter,
  marginTop: theme.custom.spacing.large,
  padding: `${theme.custom.spacing.xLarge}px ${theme.custom.spacing.large}px`,
  [mq.medium]: {
    marginTop: theme.custom.spacing.xxLarge,
    marginBottom: theme.custom.spacing.xxLarge
  }
}));

export const NoResults = () => {
  const t: any = useI18NextContext();

  useEffect(() => {
    rTapNotifyDOMChangeWrapper();
  }, []);

  const telephoneNumber = t('common__brand_telephone');
  return (
    <Container>
      <Heading
        dangerouslySetInnerHTML={getHTML(
          `${t('tours-search__no-result--heading')} ${rTapNumberHTML({ telephoneNumber })}`
        )}
      />
      <Description>{t('tours-search__no-result--body')}</Description>
    </Container>
  );
};
